module.exports = __webpack_public_path__ + "img/pilates4.caf8cfba.jpg";